<style src="./TotalEvents.scss" lang="scss"></style>
<template>
  <section class="total-events">
    <div class="participation">
      <div class="participated">
        <span class="title">PARTICIPAÇÕES</span>
        <span class="value">
          {{ participated }}
          <small class="perc perc__info">{{ participatedPerc }}%</small>
        </span>
      </div>
      <div class="participated">
        <span class="title">NÃO PARTICIPAÇÕES</span>
        <span class="value">
          {{ notParticipated }}
          <small class="perc perc__danger">{{ notParticipatedPerc }}%</small>
        </span>
      </div>
    </div>
    <div class="total">
      <span class="counttotal">
        {{ countTotal }}
      </span>
      <span>EVENTOS CADASTRADOS</span>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'TotalEvents',
    props: {
      countTotal: {
        default: null
      },
      participated: {
        default: null
      },
      notParticipated: {
        default: null
      }
    },
    computed: {
      participatedPerc () {
        if (!this.participated) { return 0 }
        const p = this.participated
        const r = ((p * 100) / this.countTotal).toFixed()
        return r
      },
      notParticipatedPerc () {
        if (!this.notParticipated) { return 0 }
        const p = this.notParticipated
        const r = ((p * 100) / this.countTotal).toFixed()
        return r
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/dashboard/components/total-events/TotalEvents.vue